import { useMutation } from "@apollo/client";

import { ResearchTypeUpdateFormInputs } from "../components/ResearchTypeUpdateForm";
import { SettingsResearchTypeEditRoute_UpdateDocument } from "../mutations.generated";

export default function useSettingsResearchTypeEditRoute_Update() {
    const [mutate, { loading, error }] = useMutation(SettingsResearchTypeEditRoute_UpdateDocument);

    const updateResearchType = (researchTypeId: string, input: ResearchTypeUpdateFormInputs) =>
        mutate({
            variables: { input: { ...input, researchTypeId: researchTypeId } },
        });

    return {
        updateResearchType,
        loading,
        error,
    };
}
